import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=1d848b58"
import script from "./Shipments.vue?vue&type=script&lang=ts"
export * from "./Shipments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports